import { StateObject } from '~src/domains/common/types/common';

const acceptFormSelector = (state: StateObject) => state.acceptForm;

const autoPayEnabledSelector = (state: StateObject) =>
  !!state.acceptForm?.autopay?.value;

const paymentSelectorErrorSelector = (state: StateObject) =>
  state.accept?.paymentSelectorError;

const acceptSubPageSelector = (state: StateObject) => state.accept?.subPage;

export {
  acceptFormSelector,
  autoPayEnabledSelector,
  paymentSelectorErrorSelector,
  acceptSubPageSelector,
};
